// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tirebdkkpmeiceqesbwj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRpcmViZGtrcG1laWNlcWVzYndqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ2NDkzNjUsImV4cCI6MjA2MDIyNTM2NX0.ppMdf3K266kZqAQGinOQ7bNKNjjsVj6Jr-yJDnQb1ac";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);